/**
 * Placed on links where teh current route needs to be saved.
 * This happens because on other pages after an action the user
 * needs to be redirected to different places based on where they
 * came from.
 * NOTE - Refer to the routeTo function in the sessionObjAPI service.
 */
export function CoreSaveRouteDirective ( sessionObjAPI ) {
  return {
    restrict: 'A',
    link    ( scope, element ) {
      function handleClick () {
        sessionObjAPI.saveRoute();
      }

      element.on('click', handleClick);

      scope.$on('$destroy', () => {
        element.off('click', handleClick);
      });
    }
  };
}
